/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Avatar } from "@octopusdeploy/design-system-components";
import type { UserResource, NamedReferenceItem } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
import workTeamImage from "../../../../resources/images/work-team.svg";
import styles from "./MemberRow.module.less";
type MemberTypes = UserResource | NamedReferenceItem;
function isUser(item: MemberTypes): item is UserResource {
    return !!(item as UserResource).Username;
}
function nameWithUsername(u: UserResource) {
    return !!u && u.DisplayName !== u.Username ? `${u.DisplayName} (${u.Username})` : u.DisplayName;
}
function namedGroup(u: NamedReferenceItem) {
    return u.DisplayIdAndName ? `${u.DisplayName} (${u.Id})` : u.DisplayName;
}
interface MemberRowProps {
    member: MemberTypes;
}
export const MemberRow: React.FC<MemberRowProps> = (props) => {
    const member = props.member;
    const usernameForAvatarText = member?.DisplayName || "";
    const image = isUser(member) ? (<Avatar type="user" size="small" src={member && member.Links && member.Links.Avatar} alt={usernameForAvatarText} text={usernameForAvatarText} isServiceUser={member && member.IsService}/>) : (<img src={workTeamImage} className={styles.groupImage} alt={member.DisplayIdAndName ? "Role" : "Security group"}/>);
    const name = isUser(member) ? nameWithUsername(member) : namedGroup(member);
    const nameLink = member && member.Id && member.Id.toLowerCase().startsWith("users-") ? ( // only internal link to Octopus controlled user accounts
    <InternalLink to={links.userPage.generateUrl({ userId: member.Id })}>{name}</InternalLink>) : (name);
    return (<div className={styles.user}>
            {image}
            <span className={styles.userName}>{nameLink}</span>
        </div>);
};
MemberRow.displayName = "MemberRow"
